<template>
  <!-- -------------------------------------------------------- -->
  <!-- 商品×店舗用オプション条件サマリ -->
  <!-- 参考 POSオプション条件サマリ(FilterSummaryOptionPos.vue) -->
  <!-- -------------------------------------------------------- -->
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>表示評価：{{ evaluationLabel }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    evaluation: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    evaluationLabel() {
      return this.$store.state.labels.evaluationsPos[this.evaluation]
    },
  },
}
</script>
